import { Table } from "./datatables/table";
import { CertificateExtraData } from "./extra-fields/certificate-extra-data";
import { ChangePassword } from "./login/change-password";
import { Login } from "./login/login";
import { Save } from "./save/save";
import { Currencies } from "./sessions/currencies";
import { Form } from "./sessions/save-session";
import { EditTranslation } from "./translations/edit-translation";
import { Notifications } from "./notifications";
import { onDocumentReady } from "../common/on-document-ready";
import { SaveCourse } from "./courses/save-course";
import { AddAddress } from "./add-address";
import { Bulk } from "./sessions/bulk/bulk";
import { CoursesBulk } from "./courses/bulk/courses-bulk";
import { EditInvoice } from "./invoice/edit-invoice";
onDocumentReady(() => {
    initializeDatatables();
    initializeExtraDataForm();
    initializeAuthForms();
    initializeGenericSaveForm();
    initializeSaveSessionForm();
    initializeTranslationForm();
    initializeCookieNotifications();
    SaveCourse.initialize();
    AddAddress.initialize();
    Bulk.init();
    CoursesBulk.init();
    EditInvoice.init();
});
function initializeDatatables() {
    new Table();
}
function initializeExtraDataForm() {
    new CertificateExtraData();
}
function initializeAuthForms() {
    new ChangePassword();
    new Login();
}
function initializeGenericSaveForm() {
    new Save();
}
function initializeSaveSessionForm() {
    new Currencies();
    new Form();
}
function initializeTranslationForm() {
    new EditTranslation();
}
function initializeCookieNotifications() {
    Notifications.doCookieNotification();
}
